import * as React from 'react';
import './facebookShareButton.module.scss';

type Props = {
    dataUrl: string;
    children?: any;
};

export class FacebookShareButton extends React.Component<Props> {
    get shareUrl() {
        const { dataUrl } = this.props;
        return `https://www.facebook.com/share.php?u=${dataUrl}`;
    }

    render() {
        const { children } = this.props;
        return (
            <a styleName="button facebook" href={this.shareUrl} target="_blank">
                {children}
            </a>
        );
    }
}
